import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const ApiClientsEditFormSkeleton: React.FC = () => {
  return (
    <Box py="24px" width="100%">
      <Skeleton height={40} sx={{ marginBottom: '24px' }} variant="rounded" width={150} />
      <Box display="flex" gap="24px">
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={40} variant="rounded" width="100%" />
      </Box>
    </Box>
  );
};
